import axios from 'axios'
import { infosCRM } from '../environment';
import getApp from "./app";

export const api = axios.create({
    baseURL: getUrl('/')
});

export const api_ff = axios.create({
    // baseURL: 'http://127.0.0.1:8001/api/'
    baseURL: 'https://hml-ffacil.univalores.com.br/api/'
});


export const { get, put, post } = api;

export const remove = api.delete;

export function login(usuario, senha) {
    return api.post('authenticate', {usuario_username: usuario, password: senha});
}


export function getUrl(path = '') {

    const BASE_URL = infosCRM.BASE_URL[process.env.ENV_NAME];

    const APP_NAME = getApp()

    //return `https://api-segasp.luby.com.br/segasp/api/api/${path.trim('/')}`;
	//return `https://api-crm.segasp-univalores.com.br/segasp/api/api/${path.trim('/')}`;
    // return `https://api.cubix.luby.net.br/segasp/api/api/${path.trim('/')}`;
    // return `https://api-cubix.univalores.com.br/segasp/api/api/`;
    return `https://api-cubix-hml.univalores.com.br/segasp/api/api/`;
    // return `http://127.0.0.1:8000/segasp/api/api/${path.trim('/')}`;
}

api.interceptors.request.use((config) => {

    const token = localStorage.getItem('api_token');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
})

export default api;

export function interceptors(cb) {

    const onSuccess = res => res;

    const onError = (err) => {
        cb(err)
        return Promise.reject(err)
    };

    api.interceptors.response.use(onSuccess, onError)
}



// WEBPACK FOOTER //
// ./src/helpers/api.js